import Vue from 'vue';
import Router from 'vue-router';
import PageNotFound from './components/PageNotFound';
import AnnouncementAdministration from './components/AnnouncementAdministration';
import SettingsPage from './components/settings/SettingsPage';

Vue.use(Router);

export default new Router({


  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: (to, from, next) => {
        next('/contacts');
      }
    },
    {
      path: '/contacts*',
      name: 'contacts'
    },
    {
      path: '/offers*',
      name: 'offers'
    },
    {
      path: '/planning*',
      name: 'plannings'
    },
    {
      path: '/analyses*',
      name: 'analyses'
    },
    {
      path: '/treatments*',
      name: 'treatments'
    },
    {
      path: '/certificates*',
      name: 'certificates'
    },
    {
      path: '/pre-invoices*',
      name: 'pre-invoices'
    },
    {
      path: '/invoices*',
      name: 'invoices'
    },
    {
      path: '/flows*',
      name: 'flows'
    },
    {
      path: '/exits*',
      name: 'exits'
    },
    {
      path: '/administration/announcements',
      name: 'announcement-administration',
      component: AnnouncementAdministration
    },
    {
      path: '/administration/settings/:section?',
      name: 'settings',
      component: SettingsPage
    },
    {
      path: '/404',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});
